import { DocumentMarriageFilterForm } from 'civil-status/view-models/document-marriage-list';
import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';

export const initialValuesDocumentMarriageSearch: DocumentMarriageFilterForm = {
  page: 0,
  rowsPerPage: 10,
  orders: {},
  year: '',
  document: '',
  registry: null,
  portion: '',
  serie: '',
  matricolaHusband: '',
  surnameHusband: '',
  nameHusband: '',
  matricolaWife: '',
  surnameWife: '',
  nameWife: '',
  operationYear: '0',
  operationDocument: '0',
  operationRegistry: '0',
  operationPortion: '0',
  operationSerie: '0',
  operationMatricolaHusband: '0',
  operationSurnameHusband: '0',
  operationNameHusband: '0',
  operationMatricolaWife: '0',
  operationSurnameWife: '0',
  operationNameWife: '0',
};

const PageDocumentMarriageSearchInitializer = (): ReactElement => {
  return (
    <FilterTableProvider initialValues={initialValuesDocumentMarriageSearch}>
      <Outlet />
    </FilterTableProvider>
  );
};

PageDocumentMarriageSearchInitializer.displayName = 'Page search marriage initializer component';

export default PageDocumentMarriageSearchInitializer;
